import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";

// Natural Earth low-res topojson (countries)
const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

// DeLand, Florida coordinates
const DELAND = [-81.3031, 29.0283];

export default function WorldMap({ variant = "dark" }) {
  const isDark = variant === "dark";
  const fill = isDark ? "rgba(255,255,255,0.06)" : "rgba(18,63,51,0.06)";
  const stroke = isDark ? "rgba(228,225,216,0.28)" : "rgba(18,63,51,0.35)";
  const dotFill = isDark ? "#E4E1D8" : "#123F33";
  const dotStroke = isDark ? "#FAFAF7" : "#FFFFFF";
  const labelFill = isDark ? "#FAFAF7" : "#123F33";

  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none" data-testid="world-map">
      <ComposableMap
        projection="geoEqualEarth"
        projectionConfig={{ scale: 220, center: [-150, 15] }}
        width={980}
        height={560}
        style={{ width: "100%", height: "100%" }}
      >
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill={fill}
                stroke={stroke}
                strokeWidth={0.6}
                style={{
                  default: { outline: "none" },
                  hover: { outline: "none" },
                  pressed: { outline: "none" },
                }}
              />
            ))
          }
        </Geographies>

        {/* Pulsing DeLand marker */}
        <Marker coordinates={DELAND}>
          <circle r={14} fill={dotFill} opacity={0.18}>
            <animate attributeName="r" values="10;22;10" dur="2.4s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.35;0;0.35" dur="2.4s" repeatCount="indefinite" />
          </circle>
          <circle r={5} fill={dotFill} stroke={dotStroke} strokeWidth={1.5} />
          <text
            textAnchor="middle"
            y={-14}
            style={{
              fontFamily: "Outfit, sans-serif",
              fontSize: 9,
              fontWeight: 600,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              fill: labelFill,
            }}
          >
            DeLand · FL
          </text>
        </Marker>
      </ComposableMap>
    </div>
  );
}
